export default __webpack_public_path__ + "static/m-filmtracker1-d50d0b99a762947bba2f92888dc084a7.jpg";